import AddIcon from '@mui/icons-material/Add'
import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/Search'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'

import LocalStorageButtons from '@components/LocalStorageButtons'
import FilterGridContainer from '@components/toolbar/FilterGridContainer'
import FilterGridItem from '@components/toolbar/FilterGridItem'
import { FilterSelectGebied } from '@components/toolbar/FilterSelectGebied'
import { FilterSelectObject } from '@components/toolbar/FilterSelectObject'
import type { Gebied } from '@models/Gebied'

import { useLocalFilters } from '../../core/hooks/useLocalFilters'
import { StyledIconButton } from '../../theme/components/StyledIconButton'
import { queryKey } from '../hooks/useGebiedswisselsSearch'
import type { GebiedswisselsSearchFilters as Filters } from '../types/GebiedswisselsSearch'

import { WISSEL_STATUSES } from './Gebiedswissels'

interface Props {
  onChange: (newFilters: Filters) => void
  filters: Filters
  initialFilters: Filters
  filterOptions: {
    gebieden: Gebied[]
  }
  onCreate: () => void
  onRefresh: () => void
  onReset: () => void
}

export const GebiedswisselsFilters = ({
  onChange,
  filters,
  initialFilters,
  onCreate,
  onRefresh,
  onReset,
  filterOptions: { gebieden },
}: Props) => {
  const { localFilters, handleFilterChange, handleZoeken, handleReset } =
    useLocalFilters<Filters>({
      filters,
      initialFilters,
      onChange,
      onRefresh,
      onReset,
    })

  const { gebied, status } = localFilters

  return (
    <FilterGridContainer>
      <FilterGridItem>
        <FilterSelectGebied
          options={gebieden}
          value={gebied}
          onFilterChange={handleFilterChange}
          label="Doel gebied"
        />
      </FilterGridItem>

      <FilterGridItem>
        <FilterSelectObject
          options={Object.entries(WISSEL_STATUSES).map(([key, val]) => ({
            code: key,
            label: val,
          }))}
          label="Status"
          filterKey="status"
          value={status}
          onFilterChange={handleFilterChange}
        />
      </FilterGridItem>

      <FilterGridItem
        minColumns="full"
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <StyledIconButton
          icon={<CloseIcon />}
          title="Reset filters"
          onClick={handleReset}
        />
        <StyledIconButton
          icon={<SearchIcon />}
          title="Zoeken"
          onClick={handleZoeken}
        />
        <Tooltip title="Projectids toevoegen">
          <IconButton onClick={onCreate}>
            <AddIcon />
          </IconButton>
        </Tooltip>

        <LocalStorageButtons
          name={queryKey}
          storable={localFilters}
          onClickLoad={handleFilterChange}
        />
      </FilterGridItem>
    </FilterGridContainer>
  )
}
